import { Routes } from '@angular/router';
import { AppPermissions } from '@my-aon/auth';
import { Navigation } from '@my-aon/layout';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./admin.component').then((m) => m.AdminComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/admin-home-page/admin-home-page.component').then((m) => m.AdminHomePageComponent),
            },
            {
                path: 'accounts',
                loadComponent: () => import('./pages/admin-accounts-page/admin-accounts-page.component').then((m) => m.AdminAccountsPageComponent),
            },
            {
                path: 'clients',
                loadComponent: () => import('./pages/admin-clients-page/admin-clients-page.component').then((m) => m.AdminClientsPageComponent),
            },
            {
                path: 'roles',
                loadComponent: () => import('./pages/admin-roles-page/admin-roles-page.component').then((m) => m.AdminRolesPageComponent),
            },
            {
                path: 'requests',
                loadComponent: () => import('./pages/admin-requests-page/admin-requests-page.component').then((m) => m.AdminRequestsPageComponent),
            },
            {
                path: 'app-settings',
                loadComponent: () => import('./pages/admin-app-settings-page/admin-app-settings-page.component').then((m) => m.AdminAppSettingsPageComponent),
            },
        ],
    },
];

export const adminNavigation: Navigation[] = [
    {
        title: '',
        id: 'admin.home',
        path: '',
        icon: {
            fa: 'fa-solid fa-house',
        },
    },
    {
        title: 'PAGE_TITLE.APP_SETTINGS',
        id: 'admin.appSettings',
        path: 'app-settings',
        requiredPermissionsAny: [AppPermissions.SYS_APP_SETTINGS_READ_SETTINGS],
    },
    {
        title: 'HEALTH.REQUESTS.PAGE_TITLE_REQUESTS',
        id: 'admin.requests',
        path: 'requests',
        requiredPermissionsAny: [AppPermissions.SYS_ADMIN_REQUESTS_READ_REQUESTS],
    },
    {
        title: 'PAGE_TITLE.ACCOUNTS',
        id: 'admin.accounts',
        path: 'accounts',
        requiredPermissionsAny: [AppPermissions.SYS_AUTH_USERS_READ_USERS],
    },
    {
        title: 'PAGE_TITLE.ROLES',
        id: 'admin.roles',
        path: 'roles',
        requiredPermissionsAny: [AppPermissions.SYS_AUTH_ROLES_READ_ROLES],
    },
    {
        title: 'PAGE_TITLE.CLIENTS',
        id: 'admin.clients',
        path: 'clients',
        requiredPermissionsAny: [AppPermissions.SYS_ADMIN_READ_ALL_CLIENTS],
    },
];
